// extracted by mini-css-extract-plugin
export default {"center":"mR4wlbTl","spinner":"mM6cW_YF","spin":"RBQoQZcU","brand":"tqjIPR5H","glyph":"uiyMbBkJ","name":"tWkAxL2H","title":"aBa6bGRJ","body":"bUQLLvBE","meta":"e69lQpZE"};